//Scroll
window.addEventListener("scroll", (ev) => {
    const scrollPosition = window.scrollY;
    if (scrollPosition > 0) {
        document.body.classList.add('scrolled');
        document.getElementById('header').classList.add('shadow');
        document.querySelector('.pdw-logo').style.maxWidth = "70%";
    } else {
        document.body.classList.remove('scrolled');
        document.getElementById('header').classList.remove('shadow');
        document.querySelector('.pdw-logo').style.maxWidth = "100%";
    }
});